import PropTypes from 'prop-types';

export default function Footer({ children, showPagination = false }) {
    return (
        <footer className="bg-bg-secondary border-t border-border-light px-4 md:px-6 py-3">
            <div className="flex items-center justify-between">
                {/* Left Side - Copyright */}
                <div className="text-xs text-text-muted">
                    © 2026 İNŞAET - Tüm hakları saklıdır.
                </div>

                {/* Center - Pagination or Children */}
                {showPagination && children && (
                    <div className="flex-1 flex justify-center">
                        {children}
                    </div>
                )}

                {/* Right Side - Version */}
                <div className="text-xs text-text-muted">
                    v1.0.0
                </div>
            </div>
        </footer>
    );
}

Footer.propTypes = {
    children: PropTypes.node,
    showPagination: PropTypes.bool,
};
